import React, { useEffect, useState } from "react";
import { Grid, Typography, Paper, Divider } from "@mui/material";
import SelectInput from "../../Components/InputComponents/SelectInput";
import CommonButton from "../../Components/InputComponents/CommonButton";

const OtherSettings = () => {
  const sessionOptions = [
    { label: "15 min", value: "15 min" },
    { label: "30 min", value: "30 min" },
    { label: "1 hour", value: "1 hour" },
    { label: "2 hours", value: "2 hours" },
  ];

  const privacyOptions = [
    { label: "GDPR", value: "GDPR" },
    { label: "CCPA", value: "CCPA" },
    { label: "None", value: "None" },
  ];

  const logRetentionOptions = [
    { label: "3 months", value: "3 months" },
    { label: "6 months", value: "6 months" },
    { label: "1 year", value: "1 year" },
    { label: "Indefinite", value: "Indefinite" },
  ];

  const themeOptions = [
    { label: "Default", value: "Default" },
    { label: "Dark Mode", value: "Dark Mode" },
    { label: "Custom Colors", value: "Custom Colors" },
  ];

  const emailTemplateOptions = [
    { label: "Standard", value: "Standard" },
    { label: "Custom", value: "Custom" },
  ];

  const [sessionTimeout, setSessionTimeout] = useState(sessionOptions[0].value);
  const [dataPrivacy, setDataPrivacy] = useState(privacyOptions[0].value);
  const [logRetention, setLogRetention] = useState(
    logRetentionOptions[0].value
  );
  const [theme, setTheme] = useState(themeOptions[0].value);
  const [emailTemplate, setEmailTemplate] = useState(
    emailTemplateOptions[0].value
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Paper
      sx={{
        padding: { xs: 2, sm: 3, md: 5 },
        margin: "auto",
        position: "relative",
        fontFamily: "Geist, sans-serif",
        minHeight: "100%",
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: 700,
          textAlign: "left",
          marginBottom: 3,
          fontFamily: "Geist, sans-serif",
        }}
      >
        General Settings
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Session Timeout
          </Typography>
          <SelectInput
            options={sessionOptions}
            value={sessionTimeout}
            onChange={(e) => setSessionTimeout(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            {" "}
            Data Privacy Compliance
          </Typography>
          <SelectInput
            options={privacyOptions}
            value={dataPrivacy}
            onChange={(e) => setDataPrivacy(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            {" "}
            Log Retention Period{" "}
          </Typography>
          <SelectInput
            options={logRetentionOptions}
            value={logRetention}
            onChange={(e) => setLogRetention(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            {" "}
            Email Templates{" "}
          </Typography>
          <SelectInput
            options={emailTemplateOptions}
            value={emailTemplate}
            onChange={(e) => setEmailTemplate(e.target.value)}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} justifyContent="flex-end" sx={{ mt: 3 }}>
        <Grid item>
          <CommonButton variant="outlined" customColor="#B0BEC5">
            Cancel
          </CommonButton>
        </Grid>
        <Grid item>
          <CommonButton variant="contained" customColor="#007BFF">
            Save
          </CommonButton>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default OtherSettings;
